module.exports = __webpack_public_path__ + "assets/img/doc_console.33ee18db.png";